import apiClient from '@/services/axios'

export async function post(bookingId, bookingTag) {

  var response = await apiClient.post(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/bookings/booking-tags/' + bookingId + '/' + bookingTag);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to post booking tag.')
}
